<div class="window-button-container">
    <button class="tilemodebutton" [ngClass]="{'fancy-button':get_TileMode()}" (click)="toggle_TileMode()"
        [ngbTooltip]="get_TileMode() ? 'Click to enable list layout' : 'Click to enable tiled layout'">
        <!--Content is css only-->
        <div>
            <div> </div>
            <div> </div>
            <div> </div>
            <div> </div>
        </div>
    </button>
</div>
<div id="spelllibrary" class="itembox vlist">
    <button class="itembox-close-button list-item center-aligned" (click)="toggleSpellLibraryMenu()">
        <header class="sectionHeader">Back to Character Sheet</header>
    </button>
    <div class="loading" *ngIf="still_loading()">Loading</div>
    <ng-container *ngIf="get_SpellLibraryMenuState()==='in'">
        <div class="charactersheet-column-container">
            <div class="charactersheet-column">
                <div class="list-item">
                    <strong>Find (in Name, Description or Traits)</strong>
                    <span class="hlist">
                        <input id="SpellsWordFilter" type=text [(ngModel)]="wordFilter" (keypress)=check_Filter() />
                        <button (click)="set_Filter()" [disabled]="wordFilter.length < 5">Show All</button>
                        <button (click)="wordFilter='';check_Filter()">Clear</button>
                    </span>
                </div>
                <div class="list-item">
                    <strong>Show spells from</strong>
                    <select [(ngModel)]="spellSource">
                        <option *ngFor="let source of ['spell library','your spellbook']; trackBy:trackByIndex;"
                            [ngValue]="source">
                            {{source}}
                        </option>
                    </select>
                </div>
                <div class="list-item">
                    <strong>
                        Show spells on level
                    </strong>
                    <span>
                        <select [(ngModel)]="showLevel">
                            <option *ngFor="let levelOption of [0,1,2,3,4,5,6,7,8,9,10]; trackBy:trackByIndex;"
                                [ngValue]="levelOption">
                                {{levelOption === 0 ? "Default" : levelOption}}
                            </option>
                        </select>
                    </span>
                </div>
                <div class="list-item">
                    <button (click)="toggle_Tradition('')" [ngClass]="{'fancy-button':(get_ShowTradition()==='')}">
                        All except Focus
                    </button>
                    <button (click)="toggle_Tradition('Arcane')"
                        [ngClass]="{'fancy-button':(get_ShowTradition()==='Arcane')}">
                        Arcane
                    </button>
                    <button (click)="toggle_Tradition('Divine')"
                        [ngClass]="{'fancy-button':(get_ShowTradition()==='Divine')}">
                        Divine
                    </button>
                    <button (click)="toggle_Tradition('Occult')"
                        [ngClass]="{'fancy-button':(get_ShowTradition()==='Occult')}">
                        Occult
                    </button>
                    <button (click)="toggle_Tradition('Primal')"
                        [ngClass]="{'fancy-button':(get_ShowTradition()==='Primal')}">
                        Primal
                    </button>
                    <button (click)="toggle_Tradition('Focus')"
                        [ngClass]="{'fancy-button':(get_ShowTradition()==='Focus')}">
                        Focus
                    </button>
                </div>
                <div class="fullsize-scroll-box vlist">
                    <ng-container *ngFor="let wizardCasting of [get_WizardSpellCasting()]; trackBy:trackByIndex;">
                        <ng-container *ngFor="let bardCasting of [get_BardSpellCasting()]; trackBy:trackByIndex;">
                            <ng-container
                                *ngFor="let sorcererCasting of [get_SorcererSpellCasting()]; trackBy:trackByIndex;">
                                <ng-container
                                    *ngFor="let descblock of [get_LearningAvailable(wizardCasting, bardCasting, sorcererCasting)]; trackBy:trackByIndex;">
                                    <div class="list-item" *ngIf="descblock.length">
                                        <ng-container
                                            *ngFor="let desc of descblock.split('\n\n'); trackBy:trackByIndex;">
                                            <app-description class="newrow" [text]="desc"></app-description>
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <ng-container
                                    *ngFor="let descblock of [get_SpellMasteryAvailable(wizardCasting)]; trackBy:trackByIndex;">
                                    <div class="list-item" *ngIf="descblock.length">
                                        <ng-container
                                            *ngFor="let desc of descblock.split('\n\n'); trackBy:trackByIndex;">
                                            <app-description class="newrow" [text]="desc"></app-description>
                                        </ng-container>
                                    </div>
                                </ng-container>
                                <ng-container
                                    *ngFor="let level of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; trackBy:trackByIndex;">
                                    <ng-container
                                        *ngFor="let visibleSpells of [get_VisibleSpells(level)]; trackBy:trackByIndex;">
                                        <button class="list-item" (click)="toggle_List(level)"
                                            [ngClass]="{'fancy-button':get_ShowList()===level||get_ShowList()===-2}"
                                            *ngIf="visibleSpells.length">
                                            <header class="sectionHeader" *ngIf="level === 0">Cantrips</header>
                                            <header class="sectionHeader" *ngIf="level > 0">{{"Level "+level}}</header>
                                        </button>
                                        <div [ngClass]="{'icon-list left-aligned':get_TileMode(), 'list-item':!get_TileMode()}"
                                            *ngIf="visibleSpells.length && get_ShowList()===level||get_ShowList()===-2">
                                            <div class="newrow list-item"
                                                *ngIf="visibleSpells.length >= 80 && get_ShowList()!==-2"
                                                (click)="set_Range(-1)">
                                                <button class="center-aligned" [disabled]="range <= 0">
                                                    Previous 40
                                                </button>
                                                <header class="newrow subsectionHeader center-aligned">
                                                    Showing {{(range * 40) + 1}}-{{(((range + 1) * 40) >=
                                                    visibleSpells.length) ?
                                                    visibleSpells.length : ((range + 1) * 40)}} of
                                                    {{visibleSpells.length}}
                                                </header>
                                            </div>
                                            <ng-container
                                                *ngFor="let spell of visibleSpells; let spellIndex = index; trackBy:trackByIndex;">
                                                <ng-container
                                                    *ngIf="visibleSpells.length < 80 || get_ShowList()===-2 || (spellIndex >= (range * 40) && spellIndex < ((range + 1) * 40 ))">
                                                    <ng-template #SpellTemplate>
                                                        <header class="spellHeader" *ngIf="get_TileMode()">
                                                            {{spell.name}}
                                                            <app-actionIcons *ngIf="spell.actions"
                                                                [actionString]="spell.actions">
                                                            </app-actionIcons>
                                                            {{spell.castType}}
                                                        </header>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'wizard')"
                                                            [disabled]="!can_Learn(wizardCasting, level, spell, 'wizard')"
                                                            *ngIf="get_AvailableForLearning(wizardCasting, spell)">
                                                            Learn as Wizard
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'school')"
                                                            [disabled]="!can_Learn(wizardCasting, level, spell, 'school')"
                                                            *ngIf="get_AvailableForLearning(wizardCasting, spell)">
                                                            Learn via School
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'esotericpolymath')"
                                                            [disabled]="!can_Learn(bardCasting, level, spell, 'esotericpolymath')"
                                                            *ngIf="get_AvailableForLearning(bardCasting, spell)">
                                                            Learn via Esoteric Polymath
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'arcaneevolution')"
                                                            [disabled]="!can_Learn(sorcererCasting, level, spell, 'arcaneevolution')"
                                                            *ngIf="get_AvailableForLearning(sorcererCasting, spell)">
                                                            Learn via Arcane Evolution
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'adaptedcantrip')"
                                                            [disabled]="!can_Learn(wizardCasting, level, spell, 'adaptedcantrip')"
                                                            *ngIf="get_AvailableForLearning(wizardCasting, spell, true)">
                                                            Learn via Adapted Cantrip
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'adaptiveadept')"
                                                            [disabled]="!can_Learn(wizardCasting, level, spell, 'adaptiveadept')"
                                                            *ngIf="get_AvailableForLearning(wizardCasting, spell, false, true)">
                                                            Learn via Adaptive Adept
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="learn_Spell(spell, 'free')"
                                                            *ngIf="!get_SpellsLearned(spell.name).length && !spell.traditions.includes('Focus')">
                                                            Learn using Learn A Spell activity
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="unlearn_Spell(spell)" [disabled]=""
                                                            *ngFor="let learned of get_SpellsLearned(spell.name); trackBy:trackByIndex;">
                                                            Unlearn {{get_LearnedSpellSource(learned.source)}}
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="add_SpellMasterySpell(spell)"
                                                            [disabled]="!get_SpellMasteryAllowed(wizardCasting, level, spell)"
                                                            *ngIf="get_AvailableForSpellMastery(wizardCasting, spell)">
                                                            <i class='ra ra-crown'></i>&nbsp;Add to Spell Mastery
                                                            selection
                                                        </button>
                                                        <button class="newrow center-aligned"
                                                            (click)="remove_SpellMasterySpell(wizardCasting, spell)"
                                                            *ngIf="get_SpellMasterySelected(wizardCasting, spell)">
                                                            <i class='ra ra-crown'></i>&nbsp;Remove from Spell Mastery
                                                            selection
                                                        </button>
                                                        <div class="list-item">
                                                            <strong>
                                                                Show spell on level
                                                            </strong>
                                                            <span>
                                                                <select [(ngModel)]="showLevel">
                                                                    <option
                                                                        *ngFor="let levelOption of [0,1,2,3,4,5,6,7,8,9,10]; trackBy:trackByIndex;"
                                                                        [disabled]="levelOption && spell.levelreq > levelOption"
                                                                        [ngValue]="levelOption">
                                                                        {{levelOption === 0 ? "Default (" +
                                                                        spell.levelreq + ")" : levelOption}}
                                                                    </option>
                                                                </select>
                                                            </span>
                                                        </div>
                                                        <app-spell [spell]="spell"
                                                            [spellLevel]="showLevel ? showLevel : level">
                                                        </app-spell>
                                                    </ng-template>
                                                    <ng-template #SpellTitleTemplate>
                                                        <span *ngIf="!get_TileMode()">
                                                            <i class="value bi-patch-plus bonus"
                                                                *ngIf="!spell.get_IsHostile()"
                                                                [ngbTooltip]="'Beneficial spell'"></i>
                                                            <i class="value bi-patch-minus-fill penalty"
                                                                *ngIf="spell.get_IsHostile()"
                                                                [ngbTooltip]="'Hostile spell'"></i>
                                                        </span>
                                                        <span>
                                                            {{spell.name}}
                                                            <app-actionIcons *ngIf="spell.actions"
                                                                [actionString]="spell.actions">
                                                            </app-actionIcons>
                                                            {{spell.castType}}
                                                        </span>
                                                    </ng-template>
                                                    <ng-container *ngIf="!get_TileMode()">
                                                        <div class="list-item">
                                                            <button class="newrow left-aligned sublist-toggle"
                                                                (click)="toggle_Item(spell.id)"
                                                                [ngClass]="{'fancy-button choicecleared':get_SpellsLearned(spell.name).length}">
                                                                <span [ngbTooltip]="'Spell Mastery spell'"
                                                                    *ngIf="get_SpellMasterySelected(wizardCasting, spell)"><i
                                                                        class='ra ra-crown'></i>
                                                                </span>
                                                                <span>
                                                                    <ng-container
                                                                        *ngTemplateOutlet="SpellTitleTemplate">
                                                                    </ng-container>
                                                                    <ng-container
                                                                        *ngFor="let trait of ['Rare', 'Uncommon']">
                                                                        <app-trait *ngIf="spell.traits.includes(trait)"
                                                                            [name]="trait"
                                                                            [trait]="get_Traits(trait)[0]">
                                                                        </app-trait>
                                                                    </ng-container>
                                                                </span>
                                                            </button>
                                                            <div class="list-item sublist"
                                                                *ngIf="get_ShowItem()===spell.id"
                                                                [ngClass]="{'fancy-list':get_SpellsLearned(spell.name).length}">
                                                                <ng-container *ngTemplateOutlet="SpellTemplate">
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="get_TileMode()">
                                                        <button
                                                            [ngClass]="{'fancy-button choicecleared':get_SpellsLearned(spell.name).length, 'penalty':spell.get_IsHostile(), 'bonus':!spell.get_IsHostile()}"
                                                            [ngbPopover]="SpellTemplate" triggers="click"
                                                            (click)="toggle_Item()">
                                                            <app-gridIcon
                                                                [ngClass]="{'fancy-button':get_SpellsLearned(spell.name).length, 'penalty':spell.get_IsHostile(), 'bonus':!spell.get_IsHostile()}"
                                                                [ngbTooltip]="SpellTitleTemplate" [title]="spell.name"
                                                                [detail]="spell.traits.includes('Rare') ? 'R' : (spell.traits.includes('Uncommon') ? 'U' : '')"
                                                                [superTitle]="get_SpellMasterySelected(wizardCasting, spell) ? 'icon-ra ra-crown' : ''"
                                                                [spell]="spell">
                                                            </app-gridIcon>
                                                        </button>
                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                            <div class="newrow list-item"
                                                *ngIf="visibleSpells.length >= 80 && get_ShowList()!==-2">
                                                <button class="center-aligned"
                                                    [disabled]="(range + 1) * 40 >= visibleSpells.length"
                                                    (click)="set_Range(1)">
                                                    Next 40
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="charactersheet-column mobile-hide">
                <app-spellbook [ngClass]="{'minimized':(get_SpellbookMinimized())}" [sheetSide]="'right'">
                </app-spellbook>
            </div>
        </div>
    </ng-container>
</div>
